import React, { useEffect, useState } from 'react';
import api, { asArray } from '../services/api';
import { PageHeader, DarkPanel, btnOnDark } from '../components/ui';
import { fmtLocal } from '../utils/time';

export default function Help() {
  const [text, setText] = useState('');
  const [messages, setMessages] = useState([]);
  const [error, setError] = useState('');
  const [ok, setOk] = useState('');
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);

  const load = () => {
    api.get('/help/mine')
      .then(r => setMessages(asArray(r.data)))
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const send = async (e) => {
    e.preventDefault();
    setError('');
    setOk('');
    if (!text.trim()) {
      setError('Please enter a message');
      return;
    }
    if (text.trim().length > 200) {
      setError('Max 200 characters');
      return;
    }
    setSending(true);
    try {
      await api.post('/help', { message: text.trim() });
      setText('');
      setOk('Message sent. Admin will respond here.');
      load();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="space-y-4 pb-8">
      <PageHeader title="Help" subtitle="Send a message to support (max 200 characters). Replies appear below." />

      <DarkPanel title="New message">
        <form onSubmit={send}>
          {error && <div className="mb-3 rounded-lg border border-rose-400/30 bg-rose-400/10 px-3 py-2 text-sm text-rose-300">{error}</div>}
          {ok && <div className="mb-3 rounded-lg border border-emerald-400/30 bg-emerald-400/10 px-3 py-2 text-sm text-emerald-300">{ok}</div>}
          <textarea
            value={text}
            onChange={e => setText(e.target.value.slice(0, 200))}
            rows={4}
            placeholder="Describe your question or issue…"
            className="w-full resize-y rounded-xl border border-white/10 bg-white/[0.04] px-3 py-2.5 text-sm text-white placeholder-slate-500 outline-none focus:ring-1 focus:ring-emerald-400/60"
          />
          <div className="mt-2 flex items-center justify-between">
            <span className={`text-xs ${text.length >= 180 ? 'text-rose-400' : 'text-slate-500'}`}>
              {text.length}/200
            </span>
            <button type="submit" disabled={sending} className={btnOnDark}>
              {sending ? 'Sending…' : 'Send'}
            </button>
          </div>
        </form>
      </DarkPanel>

      <DarkPanel title="Conversation" bodyClassName="space-y-2 p-2.5">
        {loading ? (
          <p className="py-6 text-center text-sm text-slate-400">Loading…</p>
        ) : messages.length === 0 ? (
          <p className="py-6 text-center text-sm text-slate-400">No messages yet.</p>
        ) : (
          messages.map(m => {
            const isAdmin = m.senderRole === 'ADMIN';
            return (
              <div
                key={m.id}
                className={`rounded-xl border px-4 py-3 text-sm ${
                  isAdmin ? 'ml-4 border-sky-400/20 bg-sky-400/10' : 'mr-4 border-white/5 bg-white/[0.03]'
                }`}
              >
                <div className="mb-1 flex justify-between gap-2 text-[11px] text-slate-500">
                  <span className={`font-semibold ${isAdmin ? 'text-sky-300' : 'text-slate-300'}`}>{isAdmin ? 'Support' : 'You'}</span>
                  <span>{fmtLocal(m.createdAt)}</span>
                </div>
                <p className="whitespace-pre-wrap text-slate-200">{m.message}</p>
              </div>
            );
          })
        )}
      </DarkPanel>
    </div>
  );
}
